<template>
  <div class="card">
    <div class="card-body">

        <div class="clearfix">
        <div :class="$style.sortLeft">
          <h4 class="title">My Commercials</h4>
        </div>
      </div>
      <a-table
        :columns="columns"
        :dataSource="data"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        class="utils__scrollTable"
        :scroll="{ x: '100%' }"
      >
        <div
          slot="filterDropdown"
          slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          class="custom-filter-dropdown"
        >
          <a-input
            v-ant-ref="c => searchInput = c"
            :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm)"
            style="width: 188px; margin-bottom: 8px; display: block;"
          />
          <a-button
            type="primary"
            @click="() => handleSearch(selectedKeys, confirm)"
            icon="search"
            size="small"
            style="width: 90px; margin-right: 8px"
          >Search</a-button>
          <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">Reset</a-button>
        </div>
        <a-icon
          slot="filterIcon"
          slot-scope="filtered"
          type="search"
          :style="{ color: filtered ? '#108ee9' : undefined }"
        />
        <template slot="customRender" slot-scope="text">
          <span v-if="searchText">
            <template
              v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
            >
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{text}}</template>
        </template>
        <a
          slot="id"
          slot-scope="text"
          href="javascript: void(0);"
          class="utils__link--underlined"
        >{{text}}</a>
        <span slot="customRender" slot-scope="value">{{ value.min_amount }} - {{ value.max_amount }}</span>
        <span slot="charge" slot-scope="value">{{ value.commission }} {{ value.payment_type }}</span>
        <span
          slot="status"
          slot-scope="text"
          :class="[text.status_title === 'Success' ? 'font-size-12 badge badge-success' : 'font-size-12 badge badge-default']"
        >{{text.status_title}}</span>
        <span slot="action" slot-scope="value">
          <a-button icon="edit" @click="showDrawer(value)" class="mr-1" size="small">View</a-button>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
import { apiPath } from '../../config'
export default {
  mounted() {
    this.fetch()
  },
  data: function () {
    return {
      json_fields: {
        'ID': 'id',
        'Date': 'created_at',
        'Number': 'number',
        'Provider': 'provider',
        'Amount': 'amount',
        'Profit': 'profit',
        'UTR': 'rptdetail.utr',
        'Charge': 'usercommission.customer_charge',
        'Commission': 'usercommission.commission',
        'GST': 'usercommission.gst',
        'TDS': 'usercommission.tds',
        'client_id': 'client_id',
        'IpAddress': 'rptdetail.ip_address',
        'Status': 'status.status_title',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8',
          },
        ],
      ],
      startDate: '',
      endDate: '',
      expand: false,
      form: this.$form.createForm(this),
      item: '',
      visible: false,
      pStyle: {
        fontSize: '16px',
        color: 'rgba(0,0,0,0.85)',
        lineHeight: '24px',
        display: 'block',
        marginBottom: '16px',
      },
      pStyle2: {
        marginBottom: '24px',
      },
      search_val: '',
      data: [],
      pagination: {},
      loading: false,
      searchText: '',
      searchInput: null,
      columns: [
        {
          title: 'ID',
          dataIndex: 'provider_id',
          key: 'id',
          sorter: (a, b) => a.id - b.id,
          scopedSlots: { customRender: 'id' },
        },
        {
          title: 'Provider',
          dataIndex: 'provider',
          key: 'provider',
        },
        {
          title: 'Amount',
          key: 'min_amount',
          scopedSlots: {
            customRender: 'customRender',
          },
        },
        {
          title: 'Profit',
          key: 'charge',
          scopedSlots: {
            customRender: 'charge',
          },
        },
      ],
    }
  },
  methods: {
    async fetchData() {
      const axios = require('axios')
      const response = await axios.get(apiPath + 'apps/v1/commercials?startDate=' + this.startDate + '&endDate=' + this.endDate)
      console.log(response)
      return response.data.data
    },
    startDownload() {
      this.loading = true
    },
    finishDownload() {
      this.loading = false
    },
    onChange(date, dateString) {
      console.log(dateString)
      this.startDate = dateString[0]
      this.endDate = dateString[1]
    },
    showDrawer(item) {
      console.log(item)
      this.item = item
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
    handleTableChange (pagination, filters, sorter) {
      console.log(pagination)
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      this.fetch({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        search_val: this.search_val,
        ...filters,
      })
    },
    fetch (params = {}) {
      console.log('params:', params)
      this.loading = true
      const axios = require('axios')
      axios.get(apiPath + 'apps/v1/commercials?page=' + params.page)
        .then((data) => {
          const pagination = { ...this.pagination }
          pagination.total = data.data.total
          this.loading = false
          this.data = data.data.data
          this.pagination = pagination
        })
    },
    handleSearch(selectedKeys, confirm) {
      this.loading = true
      const axios = require('axios')
      axios.get(apiPath + 'apps/v1/commercials?search_val=' + selectedKeys)
        .then((data) => {
          const pagination = { ...this.pagination }
          pagination.total = data.data.total
          this.loading = false
          this.data = data.data.data
          this.pagination = pagination
        })
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
